import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar3Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar3 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar3Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar3">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M183.171 220.595c10.808-.136 24.824-15.092 38.753-52.69 1.951-12.591.056-12.185.056-27.094 1.776-40.417-2.947-89.148-41.891-89.148-70.321 0-77.354 30.796-77.354 75.952 0 .892.016 1.792.048 2.692-1.29-.064-2.724.135-4.34.669-5.264 1.728-6.857 9.963-3.56 18.397 3.058 7.82 9.246 13.061 14.327 12.408a114.12 114.12 0 0 0 7.868 17.042c-.262 15.403-.215 40.163-1.983 46.829-2.899 10.942-17.56 17.895-17.56 17.895s59.483 56.241 89.149 53.677c17.99-.342 15.29-42.265 15.29-42.265s-16.413-5.861-20.435-12.631c-1.29-2.174-1.028-12.009-.518-21.741a63.82 63.82 0 0 0 2.142.008h.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M137.172 116.393s8.601-1.967 18.118-1.791c11.181.199 22.299 9.278 24.115 5.853 2.485-4.691-1.521-9.827-21.925-11.858-9.135-.908-12.089 2.413-20.3 7.796h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            d="M222.227 112.388c-18.564-2.732-22.801 7.446-21.757 9.389.645 1.203 2.254 1.346 3.719-.008 5.336-2.11 8.235-2.11 17.879-2.269.247-1.378.175-5.957.151-7.112h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M176.099 164.352c-.685 3.528 4.134 6.356 15.498 5.758 9.358-.493 8.936-6.49 7.104-7.43-1.832-.94-2.158 2.445-8.251 2.724-5.973.278-13.658-4.588-14.351-1.06v.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_4"
              d="M156.755 125.823c-11.261 1.29-14.144 3.871-18.19 2.214 0 0 1.354 6.921 4.867 6.921 2.166 0 4.818-1.33 7.94-2.373 0 .095-.024.199-.024.294 0 3.552 3.145 6.435 7.032 6.435 3.679 0 6.698-2.588 7-5.885 4.476 2.007 8.49 4.762 8.49 4.762s-5.854-13.65-17.115-12.36v-.008Z"
            />
            <Path
              id="Vector_5"
              d="M212.049 127.886c-6.865.908-11.627 2.27-13.061 10.091 0 0 .988-.606 2.533-1.37.9 2.381 3.361 4.093 6.268 4.093 3.663 0 6.633-2.716 6.633-6.068 0-.271-.023-.542-.063-.805.079.024.167.04.247.064 4.348 1.322 6.594 3.066 7.494 3.918.079-2.349.143-4.722.175-7.104-1.665-1.29-5.296-3.48-10.218-2.827l-.008.008Z"
            />
          </G>
          <Path
            id="hair"
            d="M52.658 36.865c.948 1.68 2.334 3.026 3.982 3.974-.923 2.381-1.067 5.002-.199 7.486 1.115 3.194 3.656 5.48 6.762 6.539.23.59.366 1.003.366 1.17.151 6.794 5.4 11.062 5.4 11.062s-5.925 8.283-3.926 14.129c1.99 5.845 7.382 2.23 7.23 9.66-.15 7.43-3.997 8.242 1.14 11.627 5.136 3.385 9.31 2.979 8.513 8.577-.804 5.599 1.92 12.671 4.747 12.671s9.03-8.625 9.03-5.495 1.41 13.913 1.41 13.913 3.879-3.138 8.068-.796c4.197 2.333 12.726 23.199 12.726 23.199s4.779-16.032 3.903-22.825c-.868-6.793-2.206-10.943-2.206-10.943s6.148-3.289 5.16-8.816c-.987-5.527-7.86-7.542-2.07-10.878 5.79-3.337 15.291-4.174 13.682-9.613-1.609-5.44-6.73-10.473-3.926-9.66 2.803.82 15.617-.303 20.595-5.965 4.977-5.663.429-8.625 7.653-12.918 7.223-4.285 15.713 4.938 19.089 5.352 3.377.406-1.895-19.591-1.895-19.591s8.091 19.4 13.618 20.857c4.731 1.25.152-4.324 4.819-4.563 4.659-.24 4.284 12.001 14.255 7.789 3.592-1.522 10.258 28.12 10.258 28.12s4.237 1.052 1.417-14.868c-2.819-15.928-7.478-23.24-7.478-23.24s7.773 1.084 7.853-7.477c.079-8.562-1.92-10.051-1.92-10.051s4.874-5.017 4.723-10.656c-.151-5.638-5.551-7.215-5.551-7.215s3.146-4.213 2.668-9.955C201.434 6.323 177.367.008 151.818.008c-37.908 0-72.568 13.897-99.175 36.865l.015-.008Z"
            fill={c.hair}
          />
          <Path
            id="Vector_6"
            d="M117.078 178.823c0 .16 0 .319-.008.478 2.222 9.222 8.697 25.572 27.619 40.999 13.706 11.165 27.102 14.566 35.942 15.45-.104-4.157.103-9.676.398-15.156-14.032-.247-30.12-4.706-44.925-17.775-7.438-6.571-13.857-14.869-19.026-23.98v-.016Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="accessories"
            d="M86.768 181.579c0 16.565 9.341 29.992 20.873 29.992 11.524 0 20.874-13.427 20.874-29.992s-9.342-29.993-20.874-29.993c-11.524 0-20.873 13.428-20.873 29.993Zm9.493 1.107c0-8.569 4.834-15.514 10.799-15.514s10.799 6.945 10.799 15.514c0 8.569-4.834 15.514-10.799 15.514s-10.8-6.945-10.8-15.514Z"
            fill={c.accessories}
          />
          <Path
            id="Vector_7"
            d="M202.827 254.959a67.79 67.79 0 0 0-1.593-.279c.478.183.749.279.749.279s2.708 41.93-15.291 42.265c-29.666 2.564-89.149-53.67-89.149-53.678l-50.077 18.549c27.205 25.763 63.943 41.564 104.368 41.564 36.714 0 70.377-13.03 96.627-34.715-14.598-5.328-33.313-11.66-45.642-13.993l.008.008Z"
            fill="#000"
          />
          <Path
            id="accessories_2"
            d="M222.609 162.449c-.135 1.537-.358 3.305-.685 5.456a299.22 299.22 0 0 1-2.978 7.685c1.848 2.357 2.978 5.463 2.978 8.88 0 7.366-5.224 13.339-11.675 13.339-.621 0-1.218-.071-1.816-.175-2.238 3.894-4.451 7.247-6.618 10.09a20.086 20.086 0 0 0 7.805 1.585c12.464 0 22.57-11.54 22.57-25.779 0-8.713-3.783-16.406-9.573-21.073l-.008-.008Z"
            fill={c.accessories}
          />
          <Path
            id="Vector_8"
            d="M206.729 180.647c-7.924-3.759-15.482-1.004-17.306-1.004-1.823 0-18.365-3.703-23.39.51-.725.613 6.523 19.783 23.39 19.791 14.495.015 18.198-18.875 17.306-19.297Zm-16.613 12.017c-13.236.136-22.347-11.667-22.299-11.731.064-.079 10.361 2.987 22.076 2.724 8.115-.183 16.08-2.516 16.008-2.469-.574.391-7.192 11.389-15.793 11.468l.008.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
        </G>
      </G>
    </Svg>
  );
};
